export enum IntegrationModel {
  Product = 'product',
  Category = 'category',
  Bundle = 'bundle',
}

export interface IntegrationSyncSummary {
  last_synced_at: string;
  sync_status: string;
  total_items: number;
  total_items_synced: number;
}

export interface IntegrationSyncItem {
  id: string;
  name: string;
  sku: string;
  listing_price: number;
  selling_price: number;
  image_url: string;
  stock_available: boolean;
  status: string;
  last_synced_at: string;
}

export interface IntegrationSyncInfo {
  sync_summary: IntegrationSyncSummary;
  sync_items: IntegrationSyncItem[];
}

export interface IntegrationSyncRequest {
  destination: string;
  model: IntegrationModel;
}
